<template>
    <div class="detail-box">
        <!--左边容器-->
        <div class="box-left">
            <div v-if="preview=='PHONE'" style="margin-top: 20px;text-align: center;letter-spacing: 10px;">
                <span>分辨率:</span>
                <el-select :value="resolvingPower" @change="chooseResolvingPower($event)">
                    <el-option label="自定义" value="CUSTOM"></el-option>
                    <el-option label="320*568" value="320*568"></el-option>
                    <el-option label="360*640" value="360*640"></el-option>
                    <el-option label="375*667" value="375*667"></el-option>
                    <el-option label="375*812" value="375*812"></el-option>
                    <el-option label="411*731" value="411*731"></el-option>
                    <el-option label="411*823" value="411*823"></el-option>
                    <el-option label="414*736" value="414*736"></el-option>
                    <el-option label="768*1024" value="768*1024"></el-option>
                    <el-option label="1024*1366" value="1024*1366"></el-option>
                </el-select>
                <div style="display: inline-block" v-if="resolvingPower=='CUSTOM'">
                    <span style="padding-left: 20px">宽:</span>
                    <el-input-number v-model="width" @change="changResolvingPower"></el-input-number>
                    <span style="padding-left: 20px">高:</span>
                    <el-input-number v-model="height" @change="changResolvingPower"></el-input-number>
                </div>
            </div>
            <div class="left-detail-box" :class="{'web-detail-box': preview=='WEB','phone-detail-box':preview=='PHONE'}"
                 :style="{height: phoneDetailBoxCustom.height,width:phoneDetailBoxCustom.width}">
                <div class="content-box" style="width: 100%;height: 100%">
                    <div class="title">{{newsData.newsTitle}}</div>
                    <div class="author">
                        作者：{{newsData.authorName}}
                    </div>
                    <div class="time">
                        {{newsData.createTime | moment}}
                    </div>
                    <div class="content">
                        <div class="abstract">
                            {{newsData.newsSubtitle}}
                        </div>
                        <div class="detail" v-html="newsData.richText">

                        </div>
                    </div>

                </div>
            </div>
            <div class="btn-box">
                <el-button type="info" plain :disabled="up" @click="changeNews('UP')">上一篇</el-button>
                <el-button type="info" plain :disabled="down" @click="changeNews('DOWN')">下一篇</el-button>
            </div>
        </div>
        <!--右边容器-->
        <div class="box-right">
            <div class="right-top" v-if="preview=='WEB'" @click="handlePreview('PHONE')">
                <i class="el-icon-mobile-phone"></i>
                <span>手机预览</span>
            </div>
            <div class="right-top" v-if="preview=='PHONE'" @click="handlePreview('WEB')">
                <i class="el-icon-view"></i>
                <span>网页预览</span>
            </div>

            <div class="right-bottom">
                <div class="content">
                    <div style="clear: both;margin-top: 20px;height: 40px">
                        <div style="float: left;font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: rgba(51, 51, 51, 1);">
                            类型
                        </div>
                        <div style="float: right;font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: rgba(51, 51, 51, 1);color: red">
                            {{newsData.newsType | formatType}}
                        </div>
                    </div>

                    <div style="clear: both;margin-top: 10px;height: 30px">
                        <div style="float: left;font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: rgba(51, 51, 51, 1);">
                            当前状态
                        </div>
                        <div style="float: right;font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: rgba(51, 51, 51, 1);color: red">
                            {{newsData.status | formatState}}
                        </div>
                    </div>

                    <div style="clear: both;margin-top: 10px;height: 93px">
                        <div class="title">级别</div>
                        <el-select v-model="grade" placeholder="请选择" style="width: 100%">
                            <el-option v-for="item in gradeList" :key="item.id" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>

                    <div v-if="newsData.newsType == 'ARTICLE'">
                        <div class="title">栏目</div>
                        <el-cascader style="width: 100%" :options="options" v-model="columnObj"
                                     @change="handleItemChange"
                                     :change-on-select="true" clearable></el-cascader>

                        <div class="title">标签</div>
                        <div>
                            <el-tag :key="tag.id" v-for="tag in dynamicTagsObj" closable :disable-transitions="false"
                                    @close="handleClose(tag)" style="margin-right: 20px;margin-bottom: 20px">
                                {{tag.labelName}}
                            </el-tag>
                            <el-button class="button-new-tag" size="small" @click="openChooseLabelDialog">+ 选择标签
                            </el-button>
                        </div>
                        <div style="clear: both;margin-top: 20px">
                            <div style="float: left;font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: rgba(51, 51, 51, 1);">
                                推荐
                            </div>
                            <el-switch style="float: right;margin-top: 6px" v-model="recommend"
                                       @change="handleRecommendChange($event)"
                                       active-color="#EC6D56"></el-switch>
                        </div>
                        <div style="margin-top: 60px">
                            <div style="float: left;font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: rgba(51, 51, 51, 1);">
                                置顶
                            </div>
                            <el-switch style="float: right;margin-top: 6px" v-model="topping" active-color="#EC6D56"
                                       @change="handleToppingChange($event)"></el-switch>
                        </div>
                    </div>

                    <div v-if="newsData.status=='TO_BE_REVIEWED' || newsData.status=='NO_PASS' || newsData.status=='DISMOUNT'">
                        <div style="clear: both;width: 100%;height: 20px"></div>
                        <div style="float: left;font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: rgba(51, 51, 51, 1);">
                            定时发布
                        </div>
                        <el-switch style="float: right;margin-top: 6px" v-model="timing"
                                   active-color="#EC6D56"></el-switch>
                        <el-date-picker v-if="timing" style="width: 100%;margin-top: 30px" v-model="publishTime"
                                        type="datetime" value-format="timestamp" placeholder="定时发布时间">
                        </el-date-picker>
                    </div>

                    <div class="opration-box">
                        <el-button type="danger" style="width: 100%;margin-bottom: 20px;margin-left: 0px"
                                   @click="publishOpration"
                                   v-if="newsData.status=='TO_BE_REVIEWED' || newsData.status=='NO_PASS' || newsData.status=='DISMOUNT'">
                            发布
                        </el-button>
                        <el-button type="danger" style="width: 100%;margin-bottom: 20px;margin-left: 0px"
                                   @click="noPassOpration"
                                   v-if="newsData.status=='TO_BE_REVIEWED'">不通过
                        </el-button>
                        <el-button type="danger" plain style="width: 100%;margin-bottom: 20px;margin-left: 0px"
                                   @click="dismountOpration" v-if="newsData.status=='RELEASE'">下架
                        </el-button>
                        <el-button type="danger" style="width: 100%;margin-bottom: 20px;margin-left: 0px"
                                   @click="updateOpration"
                                   v-if="newsData.status=='RELEASE' && newsData.newsType == 'ARTICLE'">
                            确认修改
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="选择标签" :visible.sync="dialogVisible" width="40%">
            <div>
                <div>
                    <el-tabs v-model="activeName" @tab-click="handleLabelClick"
                             style="width: 80%;display: inline-block">
                        <el-tab-pane v-for="item in labelArry" :key="item.value" :label="item.label" :name="item.value"></el-tab-pane>
                    </el-tabs>
                </div>
                <div style="margin-top: 20px">
                    <el-input placeholder="请输入名称" v-model="query.labelName" prefix-icon="el-icon-search"
                              style="width: 80%"></el-input>
                    <el-button style="margin-left: 10px" type="danger" @click="searchDialogLabel">搜索</el-button>
                </div>
                <div style="margin-top: 20px;margin-bottom: 50px;max-height: 400px">
                    <el-tag style="margin-right: 5px;cursor: default;margin-bottom: 5px" v-for="item in labelListDialog"
                            :key="item.id"
                            @click.native="chooseLabel(item)" :type="getTagType(item.id)">
                        {{item.labelName}}
                    </el-tag>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="dialogVisible=false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import api from '../../api';
    import userInfoHelper from '../../../../common/userInfo';
    import {NEWSGRADE,LABELTYPE} from "../../common/constants";

    export default {
        name: "NewsDetail",
        data() {
            return {
                newsData: {}, //数据
                currId: -1, //当前id
                preview: "WEB",  //WEB-网页预览，PHONE-手机预览
                resolvingPower: "375*812", //手机预览默认显示分辨率
                height: 812, //高
                width: 375,  //宽
                phoneDetailBoxCustom: { //自定义高宽
                    height: '964px', //高
                    width: '914px'  //宽
                },
                up: false, //按钮是否可用
                down: false,
                catchIdList: [], //id缓存列表
                currIndex: 0, //当前id在缓存列表的索引
                queryParams: { //查询参数
                    keywords: "",
                    lang: "",
                    newsType: "",
                    newsStatus: "",
                    startIndex: 0,
                    size: 1000
                },
                dynamicTags: [], //选择的标签id
                dynamicTagsObj: [], //选择的标签对象
                activeName: "PRODUCT_LABEL", //激活的tab
                dialogVisible: false,  //弹框是否显示
                labelListDialog: [], //对话框选择标签数据列表
                query: { //对话框查询参数
                    labelName: "",
                    labelType: "",
                    page: 1,
                    size: 1000
                },
                recommend: false, //是否推荐
                topping: false, //是否置顶
                timing: false, //是否定时发布
                grade: 'ONE',
                publishTime: "", //发布时间
                options: [], //栏目对应的级联数据
                columnObj: [], //选中的栏目id
                gradeList: NEWSGRADE,
                labelArry: LABELTYPE
            }
        },
        mounted() {

        },
        filters: {
            formatState(state) {
                switch (state) {
                    case 'TO_BE_REVIEWED':
                        return "待审核";
                    case 'RELEASE':
                        return "已发布";
                    case 'NO_PASS':
                        return "未通过";
                    case 'DISMOUNT':
                        return "已下架";
                }
            },
            formatType(state) {
                switch (state) {
                    case 'ARTICLE':
                        return "文章";
                    case 'NEWS':
                        return "快讯";
                }
            }
        },
        created() {
            //参数初始化
            this.currId = this.$route.query.id;
            this.queryParams.keywords = this.$route.query.keywords;
            this.queryParams.lang = this.$route.query.lang;
            this.queryParams.newsType = this.$route.query.newsType;
            this.queryParams.newsStatus = this.$route.query.newsStatus;
            this.queryParams.startIndex = (this.$route.query.page * this.$route.query.size) - (this.queryParams.size / 2);
            this.queryParams.startIndex = this.queryParams.startIndex < 0 ? 0 : this.queryParams.startIndex;
            this.initData();
        },
        methods: {
            initData() {
                //获取页面详情
                this.getNewsDetail(this.currId);
                //加载上一篇，下一篇，id缓存
                this.getNewsIdList(this.queryParams);
                //获取栏目数据
                setTimeout(() => {
                    this.getColumnList(-1, 1);
                }, 1000);
            },
            publishOpration() {
                if (this.newsData.newsType == "ARTICLE") {
                    if (this.columnObj.length == 0 || this.columnObj[0] == undefined || this.columnObj[0] == "") {
                        this.$message.success('请设置栏目！');
                        return;
                    }
                    if (this.dynamicTags.length == 0) {
                        this.$message.success('请设置标签！');
                        return;
                    }
                }
                if (this.timing && (this.publishTime.length == 0 || this.publishTime.length == "")) {
                    this.$message.success('请设置发布时间！');
                    return;
                }
                let params = {
                    newsId: this.currId,
                    labelIds: this.dynamicTags.join(","),
                    columnId: this.columnObj[this.columnObj.length - 1],
                    columnIds: this.columnObj.join(","),
                    recommend: this.recommend ? "YES" : "NO",
                    imageUrls: this.getImgSrc(this.newsData.richText).join(","),
                    topping: this.topping ? "YES" : "NO",
                    grade: this.grade,
                    status: "RELEASE",
                    timer: this.timing ? "YES" : "NO",
                    publishTime: this.publishTime,
                    userName: userInfoHelper.get().userName
                };
                this.publishNews(params);
            },
            getImgSrc(html) {
                let tem;
                const reg = /<img.+?src=('|")?([^'"]+)('|")?(?:\s+|>)/gim;
                let imageUrls = [];
                while (tem = reg.exec(html)) {
                    imageUrls.push(tem[2]);
                }
                return imageUrls;
            },
            noPassOpration() {
                let params = {
                    newsId: this.currId,
                    status: "NO_PASS",
                    userName: userInfoHelper.get().userName
                };
                this.publishNews(params);
            },
            dismountOpration() {
                let params = {
                    newsId: this.currId,
                    status: "DISMOUNT"
                };
                this.publishNews(params);
            },
            updateOpration() {
                if (this.columnObj.length == 0 || this.columnObj[0] == undefined || this.columnObj[0] == "") {
                    this.$message.success('请设置栏目！');
                    return;
                }
                if (this.dynamicTags.length == 0) {
                    this.$message.success('请设置标签！');
                    return;
                }
                let params = {
                    newsId: this.currId,
                    labelIds: this.dynamicTags.join(","),
                    columnId: this.columnObj[this.columnObj.length - 1],
                    columnIds: this.columnObj.join(","),
                    recommend: this.recommend ? "YES" : "NO"
                };
                this.$confirm('确认修改吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateNewsReview(params).then((data) => {
                        if (data.code == -1) {
                            this.$message.success('修改失败！');
                        } else {
                            this.$message.success('修改成功！');
                            this.initData();
                        }
                    });
                }).catch(() => {
                });
            },
            publishNews(params) {
                this.$confirm('确认此操作吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.publishNews(params).then((data) => {
                        if (data.code == -1) {
                            this.$message.success('操作失败！');
                        } else {
                            this.$message.success('操作成功！');
                            this.initData();
                        }
                    });
                }).catch(() => {
                });
            },
            getColumnList(parentId, columnLevel) {
                let queryColumn = { //查询参数
                    columnName: "",
                    parentId: parentId,
                    columnLevel: columnLevel,
                    lang: this.queryParams.lang,
                    page: 1,
                    size: 1000
                };
                api.getColumnList(queryColumn).then(({data}) => {
                    if (columnLevel == 1) {
                        this.options = [];
                        data.records.forEach(item => {
                            if (item.columnType != "RECOMMEND" && item.columnType != "NEWS") {
                                let child = {value: item.id + "", label: item.columnName, children: []}
                                this.options.push(child);
                                this.getColumnList(item.id);
                            }
                        });
                    } else {
                        this.formatColumnData(parentId, data.records, this.options);
                    }
                });
            },
            formatColumnData(parentId, records, source) {
                if (source.length <= 0) {
                    return;
                }
                for (let i = 0; i < source.length; i++) {
                    if (parentId == source[i].value) {
                        source[i].children = [];
                        records.forEach(a => {
                            if (a.columnType != "RECOMMEND" && a.columnType != "NEWS") {
                                let child = {value: a.id + "", label: a.columnName, children: []}
                                source[i].children.push(child);
                            }
                        });
                        return;
                    } else {
                        this.formatColumnData(parentId, records, source[i].children);
                    }
                }
            },
            handleItemChange(val) {
                this.columnObj = val;
                this.getColumnList(val[val.length - 1]);
            },
            openChooseLabelDialog() {
                this.query.labelName = "";
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
                this.dialogVisible = true;
            },
            chooseLabel(item) {
                let id = item.id + "";
                this.dynamicTags.indexOf(id) == -1 ? this.dynamicTags.push(id) : this.dynamicTags.splice(this.dynamicTags.indexOf(id), 1);
                for (let i = 0; i < this.dynamicTagsObj.length; i++) {
                    if (this.dynamicTagsObj[i].id == id) {
                        this.dynamicTagsObj.splice(i, 1);
                        return;
                    }
                }
                this.dynamicTagsObj.push(item)
            },
            handleLabelClick() {
                this.query.labelName = "";
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
            },
            handleClose(tag) {
                this.dynamicTags.splice(this.dynamicTags.indexOf(tag.id + ""), 1);
                for (let i = 0; i < this.dynamicTagsObj.length; i++) {
                    if (this.dynamicTagsObj[i].id == tag.id) {
                        this.dynamicTagsObj.splice(i, 1);
                        break;
                    }
                }
            },
            getTagType(id) {
                id = id + "";
                return this.dynamicTags.indexOf(id) == -1 ? "info" : "danger";
            },
            searchDialogLabel() {
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
            },
            getDialogLabelList(query) {
                api.getLabelList(query).then(({data}) => {
                    this.labelListDialog = data.records;
                });
            },
            changeNews(type) {
                if (type == 'UP') {
                    this.currIndex = this.currIndex - 1;
                    this.currId = this.catchIdList[this.currIndex];
                    if (this.currId == undefined) {
                        this.$message.success('没有上一页了！');
                        this.currIndex = this.currIndex + 1;
                        this.currId = this.catchIdList[this.currIndex];
                        return;
                    }
                } else {
                    this.currIndex = this.currIndex + 1;
                    this.currId = this.catchIdList[this.currIndex];
                    if (this.currId == undefined) {
                        this.$message.success('没有下一页了！');
                        this.currIndex = this.currIndex - 1;
                        this.currId = this.catchIdList[this.currIndex];
                        return;
                    }
                }
                this.getNewsDetail(this.currId);
            },
            getNewsIdList(params) {
                api.getNewsIdList(params).then(({data}) => {
                    this.catchIdList = data;
                    this.currIndex = this.catchIdList.indexOf(this.currId + "");
                });
            },
            getNewsDetail(id) {
                api.getNewsDetail({newsId: id}).then(({data}) => {
                    this.dynamicTags = [];
                    this.newsData = {...data};
                    this.newsData.recommend = data.recommend == 0 ? "YES" : "NO";
                    this.newsData.topping = data.topping == 0 ? "YES" : "NO";
                    this.recommend = data.recommend == 0 ? true : false;
                    this.topping = data.topping == 0 ? true : false;
                    this.dynamicTagsObj = data.labelDetails;
                    if (data.columnDetail) {
                        this.columnObj = data.columnIds.split(',');
                    } else {
                        this.columnObj = [];
                    }
                    this.dynamicTagsObj.forEach(item => {
                        this.dynamicTags.push(item.id + "");
                    });
                });
            },
            chooseResolvingPower(value) {
                this.resolvingPower = value;
                if (this.resolvingPower == "CUSTOM") {
                    this.height = 812;
                    this.width = 375;
                } else {
                    let hw = value.split("*");
                    this.width = Number(hw[0]);
                    this.height = Number(hw[1]);
                }
                this.phoneDetailBoxCustom.height = this.height + "px";
                this.phoneDetailBoxCustom.width = this.width + "px";
            },
            handlePreview(value) {
                this.preview = value;
                if (value == "PHONE") {
                    this.height = 812;
                    this.width = 375;
                } else {
                    this.height = 964;
                    this.width = 914;
                }
                this.phoneDetailBoxCustom.height = this.height + "px";
                this.phoneDetailBoxCustom.width = this.width + "px";
            },
            changResolvingPower() {
                this.phoneDetailBoxCustom.height = this.height + "px";
                this.phoneDetailBoxCustom.width = this.width + "px";
            },
            handleToppingChange(e) {
                this.topping ? "YES" : "NO",
                    api.newsTopping({newsId: this.currId, topping: (this.topping ? "YES" : "NO"),}).then((data) => {
                        if (data.code == -1) {
                            this.$message.success('操作失败！');
                        } else {
                            this.$message.success('操作成功！');
                        }
                    });
            },
            handleRecommendChange(e) {
                this.recommend ? "YES" : "NO",
                    api.newsRecommend({
                        newsId: this.currId,
                        recommend: (this.recommend ? "YES" : "NO"),
                    }).then((data) => {
                        if (data.code == -1) {
                            this.$message.success('操作成功！');
                        } else {
                            this.$message.success('操作成功！');
                        }
                    });
            }
        }
    }
</script>
<style type="text/css">
    .left-detail-box .detail * {
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
    }

    .left-detail-box .detail img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
    }

    .detail-box .el-tabs__nav-wrap::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: rgba(245, 249, 255, 0);
        z-index: 1;
    }
</style>
<style lang="less" scoped>
    .detail-box {
        width: 100%;
        height: 100%;
        clear: both;

        .box-left {
            width: 70%;
            height: 100%;
            float: left;
            background-color: #FFFFFF;
            overflow: auto;

            .web-detail-box {
                border: 1px solid rgba(186, 186, 186, 0.62);
                margin: auto;
                overflow: auto;
                overflow-x: hidden;
                margin-top: 10px;
            }

            .phone-detail-box {
                border: 4px solid rgba(186, 186, 186, 0.62);
                margin: auto;
                margin-top: 30px;
                overflow: auto;
                overflow-x: hidden;
            }

            .left-detail-box {
                font-size: 20px;

                .title {
                    width: 100%;
                    text-align: center;
                    font-size: 100%;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    letter-spacing: 5px;
                    margin-top: 30px;
                }
                .author {
                    font-size: 70%;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    letter-spacing: 3px;
                    text-align: center;
                    margin-top: 20px;
                }
                .time {
                    font-size: 70%;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(172, 172, 172, 1);
                    letter-spacing: 2px;
                    margin-top: 20px;
                    text-align: center;
                }
                .content {
                    width: 95%;
                    margin: auto;
                    margin-top: 20px;

                    .abstract {
                        font-size: 80%;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 1.5;
                        color: rgba(141, 141, 141, 1);
                    }

                    .detail {
                        font-size: 80%;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 1.5;
                        color: rgba(51, 51, 51, 1);
                        margin-top: 30px;
                    }
                }

            }

            .btn-box {
                text-align: center;
                margin-top: 30px;
            }
        }
        .box-right {
            width: 28%;
            height: 100%;
            float: right;
            position: relative;

            .right-top {
                height: 63px;
                width: 100%;
                background-color: #FFFFFF;
                line-height: 63px;
                text-align: center;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                letter-spacing: 10px;
            }

            .right-top:hover {
                background-color: #fcfff2;
                color: rgb(85, 85, 85);
                cursor: default;
            }

            .right-bottom {
                background-color: #FFFFFF;
                width: 100%;
                bottom: 0px;;
                top: 83px;
                position: absolute;

                .content {
                    width: 93%;
                    height: 100%;
                    margin: auto;
                    position: relative;

                    .title {
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        line-height: 21px;
                        color: rgba(51, 51, 51, 1);
                        height: 50px;
                        line-height: 50px;
                    }

                    .opration-box {
                        position: absolute;
                        width: 100%;
                        bottom: 16px;
                    }
                }
            }
        }
    }
</style>